import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CustomEncoder } from '../@core/encoders/custom-encoder';
import { Filter } from '../models/filter';
import { ProductFilter } from '../models/filters/product-filter';
import { Paging } from '../models/page';
import { Product } from '../models/product';
import { StockRequestModel } from '../models/requests/stock-request-model';
import { ResponseModel } from '../models/response-model';
import { StockResponseModel } from '../models/response/stockResponseModel';
import { SerialNumberTracker } from '../models/serial-number-tracker';
import { ProductDetailFilter } from './../models/filters/product-filter';
import { ConfigurationService } from './configuration.service';

@Injectable({
  providedIn: 'root'
})
export class ProductsService {
  private url = `${environment.url}/products`;
  private carStockUrl = `${environment.url}/carStock`;
  constructor(private http: HttpClient, private configService: ConfigurationService) { }

  readProducts(filter: Filter<ProductFilter>): Observable<ResponseModel<Paging<Array<Product>>>> {
    let params = new HttpParams({ encoder: new CustomEncoder() });
    params = params
      .set("page", filter.page.toString() || "0")
      .set("pageSize", filter.pageSize.toString() || "20")
      .set("branchCode", this.configService.readSelectedBranchAndSalesOrg().branch.code)
      .set("salesOrg", this.configService.readSelectedBranchAndSalesOrg().salesOrg.code);

    params = filter.value.text ? params.set("text", filter.value.text) : params;
    params = filter.value.ean ? params.set("ean", filter.value.ean) : params;
    params = filter.value.hasExistence ? params.set("hasExistence", "true") : params;
    params = filter.value.isService ? params.set("isService", "true") : params;
    params = filter.value.serviceTypes ? params.set("serviceTypes", filter.value.serviceTypes) : params;
    return this.http.get<ResponseModel<Paging<Array<Product>>>>(this.url, { params });
  }

  readProduct(filter: Partial<ProductDetailFilter>) {
    let params = new HttpParams({ encoder: new CustomEncoder() });
    params = filter.branchCode ? params.set('branchCode', filter.branchCode) : params;
    params = filter.currentBranchCode ? params.set('currentBranchCode', filter.currentBranchCode) : params;
    params = filter.productCode ? params.set('productCode', filter.productCode) : params;
    params = filter.salesOrg ? params.set('salesOrg', filter.salesOrg) : params;
    params = filter.hasExistence ? params.set('hasExistence', `${filter.hasExistence}`) : params;


    return this.http.get<ResponseModel<Product>>(`${environment.url}/product`, { params });
  }

  readSerial(serial: string) {
    return this.http.get<ResponseModel<SerialNumberTracker>>(`${environment.url}/products/getSerial/${serial}`);
  }

  readCarStock(request: StockRequestModel) {
    return this.http.post<ResponseModel<Array<StockResponseModel>>>(this.carStockUrl, request);
  }
}
